(function () {
    'use strict';

    function setClassWhenAtTop($window, $timeout, $rootScope) {
        var $win = angular.element($window); // wrap window object as jQuery object
        function getStateName() {
            return $rootScope.$state.current.name;
        }

        return {
            restrict: 'A',
            scope: {
                stateNames : '@'
            },
            link: function (scope, element, attrs) {

                $timeout(function() {
                    // this waits for the dom to be ready
                    if (scope.stateNames) {
                        var stateNames = scope.stateNames.split(',');
                        // when tabs change we want to recalibrate
                        scope.$watch(function () { return getStateName(); }, function (newVal, oldVal) {
                            if (newVal && (newVal !== oldVal)) {
                                if (stateNames.indexOf(newVal) !== -1) {
                                    setClass(element);
                                }
                            }
                        });

                        // just in case the tab is active when the page loaded
                        if ($(element).is(':visible')) {
                            setClass(element);
                        }
                    } else {
                        setClass(element);
                    }

                    function setClass(element) {
                        var topClass = attrs.setClassWhenAtTop; // get CSS class from directive's attribute value
                        var offsetTop = element.offset().top; // get element's offset top relative to document

                        fixToTop();

                        $win.on('scroll', function(e) {
                            fixToTop();
                        });

                        function fixToTop() {
                            if ($win.scrollTop() >= offsetTop) {
                                element.addClass(topClass);
                            } else {
                                element.removeClass(topClass);
                            }
                        }
                    }
                });
            }
        };
    };

    setClassWhenAtTop.$inject = ['$window', '$timeout', '$rootScope'];
    angular.module('ecap.common').directive('setClassWhenAtTop', setClassWhenAtTop);
})();